(function () {
  if (!document.querySelector && !window.addEventListener && !("classList" in document.createElement("p"))) return;

  var ready = function (callback, ctx) {
    if (typeof callback !== 'function') return;

    if (document.readyState !== "loading") {
      callback.apply(ctx);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        callback.apply(ctx);
      });
    }
  };

  var each = function (arr, callback, ctx) {
    var r;
    for (var i = 0; i < arr.length; i++) {
      ctx = ctx || arr[i];
      r = callback.apply(ctx, [arr[i], i]);
      if (r == false) break;
    }
  };

  // Make thing not happen until finished?
  // i.e. don't act on every window resize event, just the last one when we need it.
  var debounce = function (callback, wait, ctx) {
    var timeout, timestamp, args;
    wait = wait || 100;

    var later = function() {
      var last = new Date().getTime() - timestamp;
      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        callback.apply(ctx, args);
      }
    };

    return function () {
      ctx = ctx || this;
      args = arguments;
      timestamp = new Date().getTime();
      if (!timeout) timeout = setTimeout(later, wait);
    };
  };

  /*
    Accordian
  */

  var Accordian = function (ele, selectors) {
    this.classes = {
      open: 'accordion__section--open'
    };
    this.selectors = selectors;
    this.ele = ele;
    this.sections = this._getSections();
    this._setContentHeights();
    this._addEventListeners();
  };

  Accordian.prototype.toggleSection = function (target) {
    var targetEle = this.ele.querySelector(target);
    var currentSection = targetEle.closest(this.selectors.sections);
    var isclosed = true;
    if (currentSection.classList.contains(this.classes.open)) {
      isclosed = false;
    }

    this.closeSections();

    if (isclosed) {
      var content = currentSection.querySelector(this.selectors.content);
      currentSection.classList.add(this.classes.open);
      content.style.height = content.getAttribute('data-height');
    }
  };

  Accordian.prototype.closeSections = function () {
    each(this.sections, function (section) {
      var content = section.querySelector(this.selectors.content);
      content.style.height = '0';
      section.classList.remove(this.classes.open);
    }, this);
  };

  Accordian.prototype._addEventListeners = function () {
    var _this = this;
    this.actions = this.ele.querySelectorAll(this.selectors.actions);
    each(this.actions, function (action) {
      action.addEventListener('click', function (e) {
        var target = e.currentTarget.getAttribute('href');
        if (!action.getAttribute('data-swatch')) { // If clicking on a swatch inside the accordion, allow default behavior
          e.preventDefault();
          _this.toggleSection(target);
        }
      });
    });

    window.addEventListener('resize', debounce(function () {
      _this._setContentHeights();
    }));
  };

  Accordian.prototype._getSections = function () {
    var sectionClassName = this.selectors.sections.replace('.','');
    if (this.ele.classList.contains(sectionClassName)) {
      return [this.ele];
    } else {
      return this.ele.querySelectorAll(this.selectors.sections);
    }
  };

  Accordian.prototype._setContentHeights = function () {
    var contents = this.ele.querySelectorAll(this.selectors.content);
    each(contents, function (content) {
      var transition = window.getComputedStyle(content).transition;
      var currentHeightStyle = window.getComputedStyle(content).height;
      content.style.transition = 'none';
      content.style.height = 'auto';
      content.setAttribute('data-height', content.offsetHeight+'px');
      content.style.height = currentHeightStyle;
      content.style.transition = transition;
    });
  };

  /*
    Accordians
  */
  var Accordians = function () {
    this.selectors = {
      ele: '[data-accordion]',
      sections: '.accordion__section',
      content: '.accordion__content',
      actions: 'a'
    }
    this.init();
  };

  Accordians.prototype.init = function () {
    this.eles = document.querySelectorAll(this.selectors.ele);
    if (!this.eles.length) return;

    each(this.eles, function (ele) {
      new Accordian(ele, this.selectors);
    }, this);
  };

  /*
    Run everything
  */
  ready(function () {
    new Accordians();
  });

})();
